export default __webpack_public_path__ + "static/media/418.ca5d30f7.gif";